import React from 'react';
import { Plus, Search, Download, Eye, Send } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
export function FinanceInvoices() {
  const invoices = [{
    id: 'INV-2025-001234',
    member: 'John Doe',
    amount: 'Rp 500,000',
    date: 'Jan 10, 2025',
    status: 'Paid',
    dueDate: 'Jan 31, 2025'
  }, {
    id: 'INV-2025-001233',
    member: 'Jane Smith',
    amount: 'Rp 500,000',
    date: 'Jan 9, 2025',
    status: 'Paid',
    dueDate: 'Jan 31, 2025'
  }, {
    id: 'INV-2025-001232',
    member: 'PT Tech Indo',
    amount: 'Rp 5,000,000',
    date: 'Jan 8, 2025',
    status: 'Pending',
    dueDate: 'Jan 31, 2025'
  }];
  return <div className="min-h-screen bg-white" data-id="element-3106">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3107">
        <div className="flex items-center justify-between mb-8" data-id="element-3108">
          <div data-id="element-3109">
            <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-3110">
              Invoices
            </h1>
            <p className="text-neutral-600" data-id="element-3111">Manage and track all invoices</p>
          </div>
          <div className="flex gap-3" data-id="element-3112">
            <Button variant="secondary" data-id="element-3113">
              <Download className="w-4 h-4 mr-2" data-id="element-3114" />
              Export
            </Button>
            <Button data-id="element-3115">
              <Plus className="w-4 h-4 mr-2" data-id="element-3116" />
              New Invoice
            </Button>
          </div>
        </div>

        <Card className="mb-6" data-id="element-3117">
          <CardContent className="p-6" data-id="element-3118">
            <div className="flex gap-4" data-id="element-3119">
              <div className="flex-1 relative" data-id="element-3120">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" data-id="element-3121" />
                <Input className="pl-10" placeholder="Search invoices..." data-id="element-3122" />
              </div>
              <select className="h-9 rounded-lg border border-neutral-300 bg-white px-4 text-sm" data-id="element-3123">
                <option data-id="element-3124">All Status</option>
                <option data-id="element-3125">Paid</option>
                <option data-id="element-3126">Pending</option>
                <option data-id="element-3127">Overdue</option>
              </select>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-3128">
          <CardContent className="p-0" data-id="element-3129">
            <Table data-id="element-3130">
              <TableHeader data-id="element-3131">
                <TableRow data-id="element-3132">
                  <TableHead data-id="element-3133">Invoice #</TableHead>
                  <TableHead data-id="element-3134">Member</TableHead>
                  <TableHead data-id="element-3135">Amount</TableHead>
                  <TableHead data-id="element-3136">Issue Date</TableHead>
                  <TableHead data-id="element-3137">Due Date</TableHead>
                  <TableHead data-id="element-3138">Status</TableHead>
                  <TableHead className="text-right" data-id="element-3139">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-3140">
                {invoices.map(invoice => <TableRow key={invoice.id} data-id="element-3141">
                    <TableCell className="font-medium text-atios-primary" data-id="element-3142">
                      {invoice.id}
                    </TableCell>
                    <TableCell className="text-neutral-900" data-id="element-3143">
                      {invoice.member}
                    </TableCell>
                    <TableCell className="font-medium text-neutral-900" data-id="element-3144">
                      {invoice.amount}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-3145">
                      {invoice.date}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-3146">
                      {invoice.dueDate}
                    </TableCell>
                    <TableCell data-id="element-3147">
                      <Badge variant={invoice.status === 'Paid' ? 'success' : 'warning'} data-id="element-3148">
                        {invoice.status}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right" data-id="element-3149">
                      <div className="flex justify-end gap-2" data-id="element-3150">
                        <Button size="icon" variant="ghost" className="h-8 w-8" data-id="element-3151">
                          <Eye className="w-4 h-4" data-id="element-3152" />
                        </Button>
                        <Button size="icon" variant="ghost" className="h-8 w-8" data-id="element-3153">
                          <Download className="w-4 h-4" data-id="element-3154" />
                        </Button>
                        {invoice.status === 'Pending' && <Button size="icon" variant="ghost" className="h-8 w-8" data-id="element-3155">
                            <Send className="w-4 h-4" data-id="element-3156" />
                          </Button>}
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </div>;
}